// Hover-to-open for the header's image mega menu dropdown. Click/keyboard still work
// natively via <details>; this only adds instant-open on pointer:fine (desktop) devices.
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var CLOSE_DELAY = 200;

  document.querySelectorAll('.lp-nav2 header-menu').forEach(function (menu) {
    var details = menu.querySelector('details.lp-mega2');
    if (!details) return;
    var closeTimer = null;

    function open() {
      clearTimeout(closeTimer);
      document.querySelectorAll('.lp-nav2 details.lp-mega2[open]').forEach(function (other) {
        if (other !== details) other.removeAttribute('open');
      });
      details.setAttribute('open', '');
    }
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { details.removeAttribute('open'); }, CLOSE_DELAY);
    }

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', scheduleClose);
  });
})();
